// extracted by mini-css-extract-plugin
export var footer = "_ml-0";
export var inherit = "_ml-1";
export var input = "_ml-2";
export var modalContent = "_ml-3";
export var quillEditor = "_ml-4";
export var subtitle = "_ml-5";